module.exports = __webpack_public_path__ + "static/media/play-video.0a3351fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/play-video.png
// module id = 1828
// module chunks = 0